import { useCallback } from "react";
import * as THREE from 'three';

let camera: any, scene: any, renderer: any;
let geometry, material, mesh: any;

init();

function init() {
	camera = new THREE.PerspectiveCamera( 42, 1, 0.01, 10 );
	camera.position.z = 1;
	scene = new THREE.Scene();
	geometry = new THREE.BoxGeometry( 0.2, 0.2, 0.2 );
	material = new THREE.MeshNormalMaterial();
	mesh = new THREE.Mesh( geometry, material );
	scene.add( mesh );
	renderer = new THREE.WebGLRenderer( { antialias: true } );
	renderer.setAnimationLoop( animation );
}

function animation( time: any ) {
	if( !renderer.domElement.parentNode ) return;
	mesh.rotation.x = time / 2000;
	mesh.rotation.y = time / 1000;
	renderer.render( scene, camera );
}

function resize() {
	const container = renderer.domElement.parentNode;
	if( container ) {
		const width = container.offsetWidth;
		const height = container.offsetHeight;
		renderer.setSize( width, height );
		camera.aspect = width / height;
		camera.updateProjectionMatrix();
	}
}

window.addEventListener( 'resize', resize );
resize();

export function mount( container: any ) {
	if( container ) {
		container.insertBefore( renderer.domElement, container.firstChild );
		resize();
	} else {
		renderer.domElement.remove();
	}
}

function SpinningCube() {
  const containerRef = useCallback(mount, []);
	return <div style={{ width: "150px", justifySelf: "center"}} ref={containerRef}></div>
}

export default SpinningCube;